/* @flow */
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';

import cx from 'classnames';

import styles from './styles/InlineBlock.css';

class InlineBlock extends React.Component {
  static propTypes = {
    alignv: React.PropTypes.oneOf(['baseline', 'top', 'middle', 'bottom']),
    fullWidth: React.PropTypes.bool,
    height: React.PropTypes.oneOfType([
      React.PropTypes.number,
      React.PropTypes.oneOf(['100%']),
    ]),
  };

  static propClasses = {
    alignv: {
      top: styles.alignTop,
      middle: styles.alignMiddle,
      bottom: styles.alignBottom,
    },
    fullWidth: styles.fullWidth,
  };

  static defaultProps = {
    alignv: 'baseline',
    fullWidth: false,
    height: null,
  };

  render() {
    const { className, height, children } = this.props;
    if (height !== null) {
      return (
        <div
          className={cx(styles.this, getPropClassesFromInstance(this, ['fullWidth']), className)}>
          <div
            className={cx(styles.this, getPropClassesFromInstance(this, ['alignv']))}
            style={{ height }}
          />
          <div className={cx(styles.this, getPropClassesFromInstance(this))}>
            {children}
          </div>
        </div>
      );
    } else {
      return (
        <div className={cx(styles.this, getPropClassesFromInstance(this), className)}>
          {children}
        </div>
      );
    }
  }
}

export default InlineBlock;



// WEBPACK FOOTER //
// ./src/components/InlineBlock.jsx